import { connect } from 'react-redux';
import { initGroupsPanel, addToGroupFolder } from '../../../AddToGroupsPanel/redux/actions';
import { getHasOnlyOneChunkOfGroupsToLoad, getHasNoGroups } from '../../../AddToGroupsPanel/redux/selectors';
const mapStateToProps = (state)=>({
        hasNoGroups: getHasNoGroups(state),
        hasOnlyOneChunkOfGroupsToLoad: getHasOnlyOneChunkOfGroupsToLoad(state)
    });
const mapDispatchToProps = {
    initGroupsPanel,
    addToGroupFolder
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=AddToGroupPopup.container.js.map